import { render, staticRenderFns } from "./withdraw-records.vue?vue&type=template&id=7c44486b&scoped=true"
import script from "./withdraw-records.vue?vue&type=script&lang=js"
export * from "./withdraw-records.vue?vue&type=script&lang=js"
import style0 from "./withdraw-records.vue?vue&type=style&index=0&id=7c44486b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c44486b",
  null
  
)

export default component.exports